<script setup>
import { translate } from '@/plugins/i18n'
import { usePdpStore } from '@/stores/pdp'
import { storeToRefs } from 'pinia'
import { computed, defineAsyncComponent } from 'vue'

const BanderoleText = defineAsyncComponent(
  () => import('@/components/basic/atoms/BanderoleText.vue')
)
const BanderoleWinered = defineAsyncComponent(
  () => import('@/components/basic/atoms/BanderoleWinered.vue')
)

const pdpStore = usePdpStore()
const {
  getApiProduct: product,
  getMetaProduct: metaProduct,
  isUpdating: updating,
  getCalculated: calculated
} = storeToRefs(pdpStore)

const campaignBanner = computed(() => product.value.design?.campaign_banner)

const recommendation = computed(() => metaProduct.value.recommendation)

const text = computed(() => {
  switch (true) {
    case !!campaignBanner.value:
      return campaignBanner.value
    case recommendation.value.type === 'successor':
      return translate('product_tile_recommendation_badge_successor')
    case !!product.value.last_purchase_date:
      return translate(
        'tile_banner_already_bought',
        product.value.last_purchase_date
      )
    default:
      return null
  }
})
</script>
<template>
  <div class="w-100" v-show="!updating">
    <BanderoleText v-if="text" :text="text" :golden="campaignBanner" />
    <BanderoleWinered
      v-else-if="recommendation.is_recommendation"
      class="banderole"
      :salutation="recommendation.customer_salutation"
    />
    <BanderoleWinered
      v-if="calculated.extraBanner"
      class="banderole"
      type="general"
      :text="translate('fe_app_preview_sale')"
    />
  </div>
</template>
<style scoped>
h1 {
  line-height: var(--xxxl-font-size);
}

h1[loading='true'] {
  min-width: 70%;
  min-height: 1.5rem;
}

.banderole {
  z-index: 2;
  top: 0;
}

.banderole-recommendation :deep(svg) {
  display: none;
}

.display-sm-and-up .banderole-recommendation :deep(svg) {
  display: flex;
}
</style>
